import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./Component/Login/Login";
import DashboardNew from "./Component/Dashboard/DashboardNew";
import TournamentDashboard from "./Component/TournamentDashboard/TournamentDashboard";
import Layout from "./Component/Layout/Layout";
import EditProfile from "./Component/Profile/EditProfile";
import Settings from "./Component/Settings/Settings";
import TunamentPlayers from "./Component/TunamentPlayers/TunamentPlayers";
import TournamentSquads from "./Component/TournamentSquads/TournamentSquads";
import TournamentFixture from "./Component/TournamentFixture/TournamentFixture";
import TournamentSchedule from "./Component/TournamentSchedule/TournamentSchedule";
import LiveScores from "./Component/LiveScores/LiveScores";
import UserManagement from "./Component/UserManagement/Customer";
import Logs from "./Component/Logs/Logs";
import Cache from "./Component/Cache/Cache";
import VisitorBandwidth from "./Component/VisitorBandwidth/VisitorBandwidth";
import TeamLogos from "./Component/TeamLogos/TeamLogos";
import SponsorSettings from "./Component/SponsorSettings/SponsorSettings";
import PlayerPhotoSubmissions from "./Component/PlayerPhotoSubmissions/PlayerPhotoSubmissions";
import ModerationReports from "./Component/ModerationReports/ModerationReports";
import { SocketProvider } from "./services/GlobalSocket";

const App = () => {
  function PrivateRoute({ children }) {
    const token = localStorage.getItem("token");
    if (!token) {
      return <Navigate to="/login" replace />;
    }
    return children;
  }

  function IsLogin({ children }) {
    const token = localStorage.getItem("token");
    const IsAdmin = localStorage.getItem("IsAdmin") === "true";
    const AdminType = localStorage.getItem("AdminType");

    if (token && IsAdmin && AdminType === "Team") {
      return <Navigate to="/dashboard" replace />;
    } else if (token && IsAdmin) {
      return <Navigate to="/dashboard" replace />;
    } else {
      return children;
    }
  }

  return (
    <SocketProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <IsLogin>
                <Login />
              </IsLogin>
            }
          />

          {/* Protected routes with shared layout */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardNew />} />
            <Route
              path="tournament-dashboard"
              element={<TournamentDashboard />}
            />
            <Route path="users" element={<UserManagement />} />
            <Route path="edit-profile" element={<EditProfile />} />
            <Route path="settings" element={<Settings />} />
            <Route path="UserManagement" element={<UserManagement />} />
            <Route path="TunamentPlayers" element={<TunamentPlayers />} />
            <Route path="TournamentPlayerReview" element={<TunamentPlayers />} />
            <Route path="TournamentSquads" element={<TournamentSquads />} />
            <Route path="TournamentFixture" element={<TournamentFixture />} />
            <Route path="TournamentSchedule" element={<TournamentSchedule />} />
            <Route path="LiveScores" element={<LiveScores />} />
            <Route path="logs" element={<Logs />} />
            <Route path="cache" element={<Cache />} />
            <Route path="visitor-bandwidth" element={<VisitorBandwidth />} />
            <Route path="team-logos" element={<TeamLogos />} />
            <Route path="sponsor-settings" element={<SponsorSettings />} />
            <Route
              path="player-photo-submissions"
              element={<PlayerPhotoSubmissions />}
            />
            <Route path="moderation-reports" element={<ModerationReports />} />
            {/* Add other routes as needed */}
          </Route>
        </Routes>
      </BrowserRouter>
    </SocketProvider>
  );
};

export default App;
